'use client';

import { LazyMotion } from 'framer-motion';

// ----------------------------------------------------------------------

// Loads the animation engine after hydration instead of shipping it in the root bundle.
// Use `m` (not `motion`) from framer-motion; `strict` throws if a full `motion` component slips in.
const loadFeatures = () => import('./features').then((res) => res.default);

export function MotionLazy({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion strict features={loadFeatures}>
      {children}
    </LazyMotion>
  );
}
